import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-feature-request',
  templateUrl: './feature-request.component.html',
  styleUrls: ['./feature-request.component.scss']
})
export class FeatureRequestComponent implements OnInit {

  feature:any="";
  error=false;
  submitted = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

  }

  cancelBeta(){
    this.error = false;

    if(this.feature == ""){

      this.error = true;

    }else{

      this.okService.put("account/feature",{feature:this.feature})
      .subscribe((data:any) => {

        this.submitted = true;
  
      });
    }

  }

}
